import { useEffect, useState } from "react";
import { CommunityMediaIcon } from "./CommunityMediaIcon";
import { CommunityMediaEnum } from "../enums/CommunityMediaEnum";

type Props = {
    src: string;
    title: string;
};

export const CommunityVidePreview = ({ src, title }: Props) => {
    const [thumbnail, setThumbnail] = useState<string | null>(null);

    useEffect(() => {
        const video = document.createElement('video');

        video.src = src;
        video.crossOrigin = 'anonymous';
        video.currentTime = 1;

        const capture = () => {
            const canvas = document.createElement('canvas');

            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;

            const ctx = canvas.getContext('2d');

            if (!ctx) return;

            ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

            const image = canvas.toDataURL('image/png');

            setThumbnail(image);
        };

        video.addEventListener('loadeddata', () => {
            video.currentTime = 1;
        });

        video.addEventListener('seeked', capture);

        return () => {
            video.removeEventListener('seeked', capture);
        };
    }, [src]);

    if (!thumbnail)
        return <div style={{ display: 'flex', alignItems: 'center', background: '#f5f5f5', cursor: 'pointer' }} onClick={() => window.open(src, '_blank')}>
                    <CommunityMediaIcon type={CommunityMediaEnum.video} />
                    <span style={{ paddingRight: '12px', fontSize: 'var(--text-xs)', color: 'var(--color-dark-gray)'  }}> { title } </span>
                </div>

    return (
        <img
            src={thumbnail}
            alt="Video preview"
            style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover'
            }}
            onClick={() => window.open(src, '_blank')}
        />
    );
}